$(document).ready(function () {
  var step = 1;
  var urlParams = new URL(location.href);
  var param = new URLSearchParams(urlParams.search);
  var showSlug = param.get('contact_posted');
  var stepValue = window.location.hash;
  var elProgressStep = $('.progress-step');
  var elProgressContainer = $('.progress-container');
  var elContent = $('.contact-content');
  var formContact = $('#ContactForm');
  var elPhoneNumber = $('input[name="contact[電話番号]"');

  history.pushState({ page: 1 }, 'title 1', '#step=1');

  if (stepValue == '#step=2') {
    stepValue = `step=${step}`;
  }

  window.onpopstate = function (e) {
    stepValue = window.location.hash;
    if (stepValue) {
      if (stepValue == '#step=1') {
        backStep();
      }
    }
  };

  $('#ContactForm input').on('keypress', function (e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      nextStep();
    }
  });

  if (showSlug != null && showSlug == 'true') {
    step = 3;

    elProgressStep.eq(0).removeClass('active').addClass('done');
    elProgressStep.eq(1).addClass('done');
    elProgressStep.eq(2).addClass('active');
    elContent.addClass('d-none');
    elContent.eq(3).removeClass('d-none');
    elProgressContainer.addClass('step-3');

  } else if (showSlug == 'false') {
    alert('入力した情報が正しくありません。確認して再入力してください');
  }

  $('.contact-page .btn-next').on('click', function () {
    nextStep();
  });

  $('.policy-btn__edit').on('click', function () {
    window.location.hash = 'step=1';
    backStep();
  });

  $('.form-input').on('change', function () {
    let classConfirm = $(this).data('class');
    let val = $(this).val();
    $('.' + classConfirm).text(val);
  });

  $('.terms-checkbox').on('change', function () {
    let btnSubmit = $('.policy-btn__send');

    if ($(this).is(':checked')) {
      btnSubmit.addClass('active').css("pointer-events", "unset");
    } else {
      btnSubmit.removeClass('active').css("pointer-events", "none");
    }
  });

  $('.form-lastName, .form-firstName').on('change', function () {
    let lastName = $('.form-lastName').val();
    let firstName = $('.form-firstName').val();
    let classConfirm = $(this).data('class');

    if (lastName && firstName) {
      $('.' + classConfirm).text(lastName + ' ' + firstName);
    }
  });

  $('.form-lastName2, .form-firstName2').on('change', function () {
    let lastName = $('.form-lastName2').val();
    let firstName = $('.form-firstName').val();
    let classConfirm = $(this).data('class');

    if (lastName && firstName) {
      $('.' + classConfirm).text(lastName + ' ' + firstName);
    }
  });

  $('.form-lastNameKana, .form-firstNameKana').on('change', function () {
    let lastName = $('.form-lastNameKana').val();
    let firstName = $('.form-firstNameKana').val();
    let classConfirm = $(this).data('class');

    if (lastName && firstName) {
      $('.' + classConfirm).text(lastName + ' ' + firstName);
    }
  });

  $('.form-lastNameKana2, .form-firstNameKana2').on('change', function () {
    let lastName = $('.form-lastNameKana2').val();
    let firstName = $('.form-firstNameKana2').val();
    let classConfirm = $(this).data('class');

    if (lastName && firstName) {
      $('.' + classConfirm).text(lastName + ' ' + firstName);
    }

  });

  elPhoneNumber.on('change', function() {
    $(this).closest('.item').next().hide();
  });

  $('.button-register').on('click', function() {
    var checkError = $("#ContactForm-phone-error");

    if (checkError) {
      elPhoneNumber.closest('.item').next().hide();
    }
  });

  function nextStep() {
    let valid = formContact.valid();

    if (!valid) {
      return false;
    }

    step += 1;
    let checkStep = 0;
    if (step > 2) {
      let checkActive = $('.policy-btn__send').hasClass('active');

      if (!checkActive) {
        return false;
      }
    }

    $('.page-desc').addClass('d-none');
    $('.form-contact').addClass('d-none');
    $('.contact-page .contact-confirmation').removeClass('d-none');

    $('.progress-step').each(function () {
      $(this).removeClass('active').addClass('done');

      if ($(this).index() == step - 1) {
        $(this).addClass('active');
        checkStep = 1;
      }

      if (checkStep == 1) {
        $(this).removeClass('done');
      }

    });

    let progressStep = step;
    progressStep += 1;
    elProgressContainer.removeClass('step-' + progressStep);
    elProgressContainer.addClass('step-' + step);
    $('.step-content-' + step).removeClass('d-none');
    $('html, body').animate({ scrollTop: 0 }, 800);

    window.location.hash = 'step=2';
  }

  function backStep() {
    step = 1;

    $('.progress-step').each(function () {
      $(this).removeClass('done').removeClass('active');
      if ($(this).index() == 0) {
        $(this).addClass('active');
      }
    });

    $('.progress-container').removeClass('step-2');
    $('.container-confirmation').addClass('d-none');
    $('.page-desc, .form-contact').removeClass('d-none');

  }

  formContact.validate({
    errorClass: 'error',
    errorElement: 'span'
  });

  jQuery.validator.addClassRules({
    'form-lastName': {
      required: true,
      space: true
    },
    'form-firstName': {
      required: true,
      space: true
    },
    'form-lastNameKana': {
      required: true,
      space: true
    },
    'form-firstNameKana': {
      required: true,
      space: true
    },
    email: {
      required: true,
      email: true,
    },
    company: {
      required: true,
      space: true
    },
    department: {
      required: true,
      space: true
    },
    phone: {
      phoneEmpty: true,
      trikeThrough: true,
      number: true,
    },
    content: {
      required: true,
      space: true
    },
  });

  jQuery.extend(jQuery.validator.messages, {
    equalTo: '同じメールアドレスを入力してください。',
    required: '必須項目です。入力してください。',
    email: '必須項目です。入力してください。',
    number: '数字で入力してください。',
    maxlength: jQuery.validator.format('{0} 文字以内で入力してください。'),
    minlength: jQuery.validator.format('{0} 文字以上で入力してください。'),
  });

  $.validator.addMethod('trikeThrough', function (value, element) {
    if (value.includes('-')) {
      return false;
    }
    return true;
  }, 'ハイフンを入れずに入力してください。<br/>数字で入力してください。');

  $.validator.addMethod('space', function (value, element) {
    if (value.trim() == '') {
      return false;
    }
    return true;
  }, '必須項目です。入力してください。');

  $.validator.addMethod('phoneEmpty', function (value, element) {
    if (value.trim() == '') {
      return false;
    }
    return true;
  }, '必須項目です。入力してください。<br/>ハイフンを入れずに入力してください。');
});
